import { render, staticRenderFns } from "./ProductBaseResume.vue?vue&type=template&id=12013368&scoped=true"
import script from "./ProductBaseResume.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductBaseResume.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductBaseResume.vue?vue&type=style&index=0&id=12013368&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12013368",
  null
  
)

export default component.exports